import { PERIOD_COLUMN_WIDGET_TYPE } from '../../../utils/periodColumnWidget';
import { ENVIRONMENTAL_STATUS_WIDGET_TYPE } from '../../../widgets/environmentalStatusConfig';
import { ASSET_STATUS_WIDGET_TYPE, STATUS_ARROW_WIDGET_TYPE } from '../../../widgets/assetStatusUtils';
import { WATER_TANK_WIDGET_TYPE } from './webDashboardConstants';

export const buildDefaultWidgetPropsByType = ({
  defaultChartProps,
  defaultPeriodColumnProps,
  defaultGaugeProps,
  defaultLiquidProps,
  defaultWaterTankProps,
  defaultRadialGaugeProps,
  defaultLabelProps,
  defaultLEDProps,
  defaultTextTitleProps,
  defaultTimeRangeProps,
  defaultEnvironmentalStatusProps,
  defaultNumberProps,
  defaultSliderProps,
  defaultSwitchProps,
  defaultPushButtonProps,
  defaultTerminalProps,
  defaultKeypadProps,
  defaultMenuProps,
  defaultSegmentSwitchProps,
  defaultImageButtonProps,
  defaultBackgroundImageProps,
  defaultTextProps,
  defaultTableProps,
  defaultFanProps,
  defaultPipeProps,
  defaultElbowProps,
  defaultWaterPumpProps,
  defaultBoxWidgetProps,
  defaultCameraStreamProps,
  defaultAssetStatusProps,
  defaultStatusArrowProps,
}) => ({
  chart: defaultChartProps,
  [PERIOD_COLUMN_WIDGET_TYPE]: defaultPeriodColumnProps,
  gauge: defaultGaugeProps,
  'radial-gauge': defaultRadialGaugeProps,
  label: defaultLabelProps,
  led: defaultLEDProps,
  number: defaultNumberProps,
  slider: defaultSliderProps,
  switch: defaultSwitchProps,
  'push-button': defaultPushButtonProps,
  terminal: defaultTerminalProps,
  text: defaultTextProps,
  menu: defaultMenuProps,
  'segment-switch': defaultSegmentSwitchProps,
  'background-image': defaultBackgroundImageProps,
  'image-button': defaultImageButtonProps,
  keypad: defaultKeypadProps,
  table: defaultTableProps,
  fan: defaultFanProps,
  pipe: defaultPipeProps,
  elbow: defaultElbowProps,
  'water-pump': defaultWaterPumpProps,
  liquid: defaultLiquidProps,
  [WATER_TANK_WIDGET_TYPE]: defaultWaterTankProps,
  'text-title': defaultTextTitleProps,
  'time-range': defaultTimeRangeProps,
  [ENVIRONMENTAL_STATUS_WIDGET_TYPE]: defaultEnvironmentalStatusProps,
  'box-widget': defaultBoxWidgetProps,
  'camera-stream': defaultCameraStreamProps,
  [ASSET_STATUS_WIDGET_TYPE]: defaultAssetStatusProps,
  [STATUS_ARROW_WIDGET_TYPE]: defaultStatusArrowProps,
});

export const buildWidgetPalettePropsByKey = ({
  defaultChartProps,
  previewPeriodColumnProps,
  defaultGaugeProps,
  defaultLiquidProps,
  defaultWaterTankProps,
  defaultRadialGaugeProps,
  defaultLabelProps,
  defaultLEDProps,
  defaultNumberProps,
  defaultSliderProps,
  defaultSwitchProps,
  defaultPushButtonProps,
  defaultTerminalProps,
  defaultTextProps,
  defaultMenuProps,
  defaultSegmentSwitchProps,
  defaultImageButtonProps,
  defaultBackgroundImageProps,
  defaultKeypadProps,
  defaultTableProps,
  defaultFanProps,
  defaultPipeProps,
  defaultWaterPumpProps,
  defaultElbowProps,
  defaultTextTitleProps,
  defaultTimeRangeProps,
  defaultEnvironmentalStatusProps,
  defaultBoxWidgetProps,
  defaultCameraStreamProps,
  defaultAssetStatusProps,
  defaultStatusArrowProps,
}) => ({
  defaultChartProps,
  previewPeriodColumnProps,
  defaultGaugeProps,
  defaultLiquidProps,
  defaultWaterTankProps,
  defaultRadialGaugeProps,
  defaultLabelProps,
  defaultLEDProps,
  defaultNumberProps,
  defaultSliderProps,
  defaultSwitchProps,
  defaultPushButtonProps,
  defaultTerminalProps,
  defaultTextProps,
  defaultMenuProps,
  defaultSegmentSwitchProps,
  defaultImageButtonProps,
  defaultBackgroundImageProps,
  defaultKeypadProps,
  defaultTableProps,
  defaultFanProps,
  defaultPipeProps,
  defaultWaterPumpProps,
  defaultElbowProps,
  defaultTextTitleProps,
  defaultTimeRangeProps,
  defaultEnvironmentalStatusProps,
  defaultBoxWidgetProps,
  defaultCameraStreamProps,
  defaultAssetStatusProps,
  defaultStatusArrowProps,
});

export const getDefaultWidgetPropsForType = (type, defaultWidgetPropsByType) => (
  defaultWidgetPropsByType[type] || {}
);

export const WEB_DASHBOARD_WIDGET_PALETTE = [
  { id: 'base-chart', key: 0, type: 'chart', titleKey: 'chart', extraPropsKey: 'defaultChartProps' },
  { id: 'base-period-column', key: 'base-period-column', type: PERIOD_COLUMN_WIDGET_TYPE, titleKey: 'periodColumn', fallbackTitle: 'Period Column', extraPropsKey: 'previewPeriodColumnProps' },
  { id: 'base-gauge', key: 1, type: 'gauge', titleKey: 'gauge', extraPropsKey: 'defaultGaugeProps' },
  { id: 'base-radial-gauge', key: 2, type: 'radial-gauge', titleKey: 'radialGauge', extraPropsKey: 'defaultRadialGaugeProps' },
  { id: 'base-label', key: 3, type: 'label', titleKey: 'label', extraPropsKey: 'defaultLabelProps' },
  { id: 'base-led', key: 4, type: 'led', titleKey: 'led', extraPropsKey: 'defaultLEDProps' },
  { id: 'base-number', key: 5, type: 'number', titleKey: 'number', extraPropsKey: 'defaultNumberProps' },
  { id: 'base-slider', key: 6, type: 'slider', titleKey: 'slider', extraPropsKey: 'defaultSliderProps' },
  { id: 'base-switch', key: 7, type: 'switch', titleKey: 'switch', extraPropsKey: 'defaultSwitchProps' },
  { id: 'base-push-button', key: 71, type: 'push-button', titleKey: 'pushButton', fallbackTitle: 'Push Button', extraPropsKey: 'defaultPushButtonProps' },
  { id: 'base-terminal', key: 8, type: 'terminal', titleKey: 'terminal', extraPropsKey: 'defaultTerminalProps' },
  { id: 'base-text', key: 9, type: 'text', titleKey: 'text', extraPropsKey: 'defaultTextProps' },
  { id: 'base-menu', key: 10, type: 'menu', titleKey: 'menu', extraPropsKey: 'defaultMenuProps' },
  { id: 'base-segment-switch', key: 11, type: 'segment-switch', titleKey: 'segmentSwitch', extraPropsKey: 'defaultSegmentSwitchProps' },
  { id: 'base-image-button', key: 12, type: 'image-button', titleKey: 'imageButton', extraPropsKey: 'defaultImageButtonProps' },
  { id: 'base-background-image', key: 13, type: 'background-image', titleKey: 'backgroundImage', extraPropsKey: 'defaultBackgroundImageProps' },
  { id: 'base-keypad', key: 14, type: 'keypad', titleKey: 'keypad', extraPropsKey: 'defaultKeypadProps' },
  { id: 'base-table', key: 'base-table', type: 'table', titleKey: 'table', extraPropsKey: 'defaultTableProps', includeDefaultDivSize: false },
  { id: 'base-fan', key: 15, type: 'fan', titleKey: 'fan', extraPropsKey: 'defaultFanProps' },
  { id: 'base-pipe', key: 16, type: 'pipe', titleKey: 'pipe', extraPropsKey: 'defaultPipeProps' },
  { id: 'base-elbow', key: 17, type: 'elbow', titleKey: 'elbow', extraPropsKey: 'defaultElbowProps' },
  { id: 'base-water-pump', key: 170, type: 'water-pump', titleKey: 'waterPump', fallbackTitle: 'PUMP Widget', extraPropsKey: 'defaultWaterPumpProps' },
  { id: 'base-liquid', key: 'base-liquid', type: 'liquid', titleKey: 'liquid', fallbackTitle: 'Liquid Widget', extraPropsKey: 'defaultLiquidProps' },
  { id: 'base-water-tank', key: 'base-water-tank', type: WATER_TANK_WIDGET_TYPE, titleKey: 'waterTank', fallbackTitle: 'Water Tank', extraPropsKey: 'defaultWaterTankProps', heightSource: 'width' },
  { id: 'base-text-title', key: 18, type: 'text-title', titleKey: 'textTitle', fallbackTitle: 'Title Widget', extraPropsKey: 'defaultTextTitleProps' },
  { id: 'base-time-range', key: 19, type: 'time-range', titleKey: 'timeRange', fallbackTitle: 'Digital Clock', extraPropsKey: 'defaultTimeRangeProps' },
  { id: 'base-environmental-status', key: 132, type: ENVIRONMENTAL_STATUS_WIDGET_TYPE, titleKey: 'environmentalStatus', fallbackTitle: 'Environmental Status', extraPropsKey: 'defaultEnvironmentalStatusProps' },
  { id: 'base-box-widget', key: 131, type: 'box-widget', titleKey: 'boxWidget', fallbackTitle: 'Box Widget', extraPropsKey: 'defaultBoxWidgetProps' },
  { id: 'base-asset-status', key: 133, type: ASSET_STATUS_WIDGET_TYPE, titleKey: 'assetStatus', fallbackTitle: 'Asset Status', extraPropsKey: 'defaultAssetStatusProps', paletteWidth: 194, paletteHeight: 150 },
  { id: 'base-status-arrow', key: 134, type: STATUS_ARROW_WIDGET_TYPE, titleKey: 'statusArrow', fallbackTitle: 'Status Arrow', extraPropsKey: 'defaultStatusArrowProps', paletteWidth: 194, paletteHeight: 86 },
  { id: 'base-camera-stream', key: 135, type: 'camera-stream', titleKey: 'cameraStream', fallbackTitle: 'Camera Stream', extraPropsKey: 'defaultCameraStreamProps' },

];

export const getWidgetPaletteTitle = (definition, t = {}) => (
  t.widgetTitles?.[definition.titleKey] || definition.fallbackTitle
);

export const sortWebDashboardWidgets = (widgets) => {
  const backgroundWidgets = (widgets || []).filter(
    (widget) => widget.type === 'background-image' || widget.type === 'box-widget',
  );

  const otherWidgets = (widgets || []).filter(
    (widget) => widget.type !== 'background-image' && widget.type !== 'box-widget' && widget.type !== STATUS_ARROW_WIDGET_TYPE,
  );

  const arrowWidgets = (widgets || []).filter(
    (widget) => widget.type === STATUS_ARROW_WIDGET_TYPE,
  );

  return [...backgroundWidgets, ...otherWidgets, ...arrowWidgets];
};

export const getWidgetPropsFromType = ({
  type,
  defaultWidgetPropsByType,
  cloneDashboardValue,
}) => {
  const nextProps = cloneDashboardValue(getDefaultWidgetPropsForType(type, defaultWidgetPropsByType));
  if (typeof nextProps.showTitle !== 'boolean') {
    nextProps.showTitle = true;
  }
  return nextProps;
};
